module.exports = __webpack_public_path__ + "img/zz.9bc53685.jpg";